import SelectCandidatesFormContainer from './select_candidates_form_container';

const SelectCandidatesForm = SelectCandidatesFormContainer;
export default SelectCandidatesForm;
